import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_URI;

class BlogInteractionService {
  async trackView(blogId) {
    try {
      await axios.post(`${API_BASE_URL}/api/blogs/${blogId}/views`);
      return true;
    } catch (error) {
      console.error('Error tracking view:', error);
      return false;
    }
  }

  async trackShare(blogId) {
    try {
      await axios.post(`${API_BASE_URL}/api/blogs/${blogId}/shares`);
      return true;
    } catch (error) {
      console.error('Error tracking share:', error);
      return false;
    }
  }

  async trackLike(blogId) {
    try {
      const headers = getAuthHeaders();
      if (!headers) {
        throw new Error('Authentication required');
      }
      await axios.post(`${API_BASE_URL}/api/blogs/${blogId}/likes`, {}, { headers });
      return true;
    } catch (error) {
      if (error.message === 'Authentication required') {
        throw new Error('Please login to like this post');
      }
      console.error('Error tracking like:', error);
      throw error;
    }
  }

  async getInteractionCounts(blogId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/blogs/${blogId}/interactions`);
      return response.data.data || { views: 0, likes: 0, shares: 0 };
    } catch (error) {
      console.error('Error fetching interaction counts:', error);
      return { views: 0, likes: 0, shares: 0 };
    }
  }
}

export const blogInteractionService = new BlogInteractionService(); 